<template>
    <div></div>
</template>

<script>
    export default {
        name: 'NotAuthenticated',
        methods: {

        },
        created() {
            window.location.replace(process.env.VUE_APP_B2B_AUTH_FRONTEND);
        }
    }
</script>

